import { Controller } from "@hotwired/stimulus";

// The meta-search clicked-price-vs-actual-price mismatch notice
// (step_1_meta_price_change, in _errors.html.erb) -- replaces its old
// fancybox open/close wiring with the site-wide Tailwind dialog pattern.
// Only rendered server-side when there actually is a mismatch, so this
// only ever needs a close step, no open trigger.
export default class extends Controller {
  static targets = ["metaPriceDialog"];

  closeMetaPriceDialog() {
    this.metaPriceDialogTarget.remove();
  }

  // Wired on the dialog's own backdrop element -- event.currentTarget is
  // always that backdrop; event.target is whatever was actually clicked,
  // equal only when the click landed on the backdrop itself, not a
  // bubbled click from the card content inside it.
  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.closeMetaPriceDialog();
  }
}
